import {createAction} from '@ngrx/store';


export class DialogDeleteConfigurationActions {

  private static readonly prefix = '[Dialog Delete Configuration]';

  public static open = createAction(
    `${this.prefix} Open dialog`,
  );

  public static close = createAction(
    `${this.prefix} Close dialog`,
  );

}
